import tools from '@/utils/tools';

//获取文件地址
const getPath = async function(params,that){
  var url = "/backend/upload/getPath.html"
  const res = await tools.post(url,params,that);
  return res
}

//获取图片列表
const getImgList = async function(params,that){
  var url = "/backend/upload/getImgList.html"
  const res = await tools.post(url,params,that);
  return res
}

//设置路径
const setPath = async function(params,that){
  var url = "/backend/upload/setPath.html"
  const res = await tools.post(url,params,that);
  return res
}

//删除图片
const delimg = async function(params,that){
  var url = "/backend/upload/delimg.html"
  const res = await tools.post(url,params,that);
  return res
}

//删除视频
const removeVideo = async function(params,that){
  var url = "/backend/upload/removeVideo.html"
  const res = await tools.post(url,params,that);
  return res
}

//删除文件
const removeFile = async function(params,that){
  var url = "/backend/upload/removeFile.html"
  const res = await tools.post(url,params,that);
  return res
}

//上传文件
const uploadImg = async function(params,that){
  var url = "/backend/upload/uploadImg.html"
  const res = await tools.post(url,params,that);
  return res
}

//上传文件
const uploadFile = async function(params,that){
  var url = "/backend/upload/uploadFile.html"
  const res = await tools.post(url,params,that);
  return res
}

//上传文件
const uploadVideo = async function(params,that){
  var url = "/backend/upload/uploadVideo.html"
  const res = await tools.post(url,params,that);
  return res
}

const fileFunction = {
  getPath,
  getImgList,
  setPath,
  delimg,
  removeFile,
  removeVideo,
  uploadFile,
  uploadImg,
  uploadVideo
}

export default fileFunction;


// WEBPACK FOOTER //
// ./src/api/file.js